export default function HouseIcon({ className }) {
  return (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="128.000000pt"
      height="128.000000pt"
      viewBox="0 0 128.000000 128.000000"
      preserveAspectRatio="xMidYMid meet"
      className={className}
    >
      <g transform="translate(0.000000,128.000000) scale(0.100000,-0.100000)">
        <path
          d="M762 1188 c-7 -7 -12 -39 -12 -75 l0 -63 -289 0 c-219 0 -291 -3
   -299 -12 -8 -10 -105 -299 -156 -464 -8 -27 16 -54 50 -54 l24 0 0 -185 0
   -185 -29 0 c-35 0 -55 -22 -46 -50 6 -20 10 -20 635 -20 625 0 629 0 635 20 9
   28 -11 50 -46 50 l-29 0 0 185 0 185 24 0 c34 0 58 27 50 54 -51 165 -148 454
   -156 464 -6 7 -35 12 -74 12 l-64 0 0 63 c0 36 -5 68 -12 75 -16 16 -190 16
   -206 0z m138 -98 c0 -39 -1 -40 -35 -40 -34 0 -35 1 -35 40 0 39 1 40 35 40
   34 0 35 -1 35 -40z m226 -302 l62 -188 -192 0 -192 0 -74 75 c-41 41 -81 75
   -90 75 -9 0 -49 -34 -90 -75 l-74 -75 -193 0 -192 0 60 178 c32 97 61 183 64
   190 3 10 94 12 426 10 l422 -3 63 -187z m-417 -195 l61 -68 180 -3 180 -3 0
   -185 0 -184 -190 0 -190 0 0 138 c0 94 -4 142 -12 150 -13 13 -163 17 -192 6
   -14 -5 -16 -28 -16 -150 l0 -144 -190 0 -190 0 0 185 0 185 176 0 177 0 65 70
   c36 39 68 70 73 70 4 0 35 -30 68 -67z m-31 -330 l3 -113 -41 0 -40 0 0 108
   c0 60 3 112 7 116 4 4 21 6 38 4 l30 -3 3 -112z"
        />
        <path
          d="M242 442 c-9 -6 -12 -35 -10 -108 l3 -99 105 0 105 0 3 99 c2 73 -1
   102 -10 108 -7 4 -51 8 -98 8 -47 0 -91 -4 -98 -8z m136 -104 l3 -38 -40 0
   c-40 0 -41 1 -41 33 0 42 7 49 45 45 27 -3 30 -7 33 -40z"
        />
        <path
          d="M842 442 c-9 -6 -12 -35 -10 -108 l3 -99 105 0 105 0 3 99 c2 73 -1
   102 -10 108 -7 4 -51 8 -98 8 -47 0 -91 -4 -98 -8z m136 -104 l3 -38 -40 0
   c-40 0 -41 1 -41 33 0 42 7 49 45 45 27 -3 30 -7 33 -40z"
        />
      </g>
    </svg>
  );
}
